import React, { useEffect, useState } from 'react';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { getSPBillsHistory } from '../services/api/implementation/impl';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Header from '../../shared/components/layout/Header';
import Layout from '../components/layout/AppLayout';
// import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import Loader from '../../shared/components/ui/Loader';
import { useQuery } from '@tanstack/react-query';
import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import PerformaInvoiceHistory from './PerformaInvoiceHistory';

const PayablesHistory = () => {
  const { collapsed } = useSidebar();
  // pagination
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // items per page

  // tabs
  const [activeTab, setActiveTab] = useState('Service Provider Bills');
  const tabsMeta = { tabs: ['Service Provider Bills', 'Performa Invoice Bills'] };

  const {
    data: PayablesHistory,
    refetch: refetchPayablesHistory,
    isFetching: isFetchingPayables
  } = useQuery({
    queryKey: ['payablesHistory', page],
    queryFn: () => getSPBillsHistory(page, limit),
    keepPreviousData: true
  });

  const totalPages = PayablesHistory?.meta ? Math.ceil(PayablesHistory?.meta.total / limit) : 1;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    refetchPayablesHistory();
  }, []);

  const InvoiceFormat = ['id', 'name', 'project', 'bill_id', 'amount', 'created_at'];

  const PayableData = PayablesHistory?.data?.map((item) =>
    transformData(
      {
        ...item,
        id: item.id,
        name: item?.bill?.user?.name,
        project: item?.bill?.project?.name,
        bill_id: item?.bill_id,
        amount: item?.amount_paid,
        created_at: item?.created_at
      },
      InvoiceFormat
    )
  );

  return (
    <>
      <Layout>
        <Loader isVisible={isFetchingPayables} />
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: `Payments History` }} />

          <SecondaryTabbedComponent
            data={tabsMeta}
            activePrimary={activeTab}
            onChangePrimaryTab={setActiveTab}
            rounded={true}
          />
        </div>

        {activeTab === 'Service Provider Bills' && (
          <div className="w-full   z-5 bg-gray-100 rounded-t-lg flex flex-col items-center gap-4">
            {PayableData && PayableData?.length > 0 ? (
              <>
                {/* Grid */}

                <GridWrapper width={100} childrenCustomStyle="m-3">
                  <div className="table-container mt-[10rem] h-[calc(100vh-12rem)] overflow-auto">
                    <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
                    <Table
                      headers={['Service Provider', 'Project', 'Bill ID', 'Amount', 'Date']}
                      data={PayableData}
                      identifier={'id'}
                      isViewEnable={false}
                      isEditEnable={false}
                      isDeleteEnable={false}
                      onDelete={() => {}}
                      isWrap={true}
                    />
                    <PaginationComponent
                      page={page}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      isFetching={isFetchingPayables}
                    />
                  </div>
                </GridWrapper>
              </>
            ) : (
              <div className="pt-[3rem]">
                <NoDataFound disabledBtn screenHeight={true} />
              </div>
            )}
          </div>
        )}

        {activeTab === 'Performa Invoice Bills' && (
          <div className="mt-6">
            <PerformaInvoiceHistory />
          </div>
        )}
      </Layout>
    </>
  );
};

export default PayablesHistory;
